module.exports = __webpack_public_path__ + "img/289.657b8b56.png";